import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import classes from '../WorkQComponent.module.css'
import policeClasses from './PoliceReportWorkQ.module.css'
import faxClasses from './invalidFax/InvalidFaxWorkQ.module.css'
import Pagination from '../pagination/Pagination'
import PoliceReportWorkQLoading, { PoliceReportListSkeleton } from './PoliceReportWorkQLoading'
import InvalidFaxDetails from './invalidFax/InvalidFaxDetails'

export default function InvalidFaxWorkQ({ loading, patientsList }) {
    const navigate = useNavigate()
    const { patientId } = useParams()
    const [listIsLoaded, setListIsLoaded] = useState(false)
    const showDetailsPanel = Boolean(patientId) || listIsLoaded

    const showListSkeleton = useSelector((state) => {
        if (!state.filter.loading) return false
        if (state.filter.snapshotData) return false
        return state.filter.currentpagedata == null
    })

    useEffect(() => {
        if (patientsList && patientsList.links && patientsList.links.first?.includes('work-queues-invalid-fax')) {
            setListIsLoaded(true)

            if (Array.isArray(patientsList.data) && patientsList.data.length > 0 && !patientId) {
                const firstId = patientsList.data[0]?.id
                if (firstId) {
                    navigate(`./${firstId}`, { replace: true })
                }
            }
        }
    }, [patientsList, patientId, loading, navigate])

    if (showListSkeleton && !patientId) {
        return <PoliceReportWorkQLoading showDetails={false} />
    }

    if (showListSkeleton && patientId) {
        return (
            <div className={classes.police_report_main}>
                <PoliceReportListSkeleton />
                <InvalidFaxDetails />
            </div>
        )
    }

    return <>
        {(patientsList || patientId) && <>
            <div className={classes.police_report_main}>
                <div className={classes.police_report_list}>
                    {Array.isArray(patientsList?.data) && patientsList.data.map(item => (
                        <div key={item.id} className={policeClasses.list_item}>
                            <Link
                                to={`/work-queues/invalid-fax-q/${item.id}`}
                                className={`${policeClasses.list_item_detail} ${String(item.id) === String(patientId) ? policeClasses.list_item_detail_active : ''}`}
                            >
                                <div className={policeClasses.list_item_name}>{item.name}</div>
                                <div className={policeClasses.flex_wrapper}>
                                    <span className={faxClasses.code_chip}>{item.code ? item.code : 'Law firm'}</span>
                                    <span className={faxClasses.count_pill} title={`${item.invalid_count} invalid`}>{item.invalid_count}</span>
                                </div>
                            </Link>
                        </div>
                    ))}
                    {Array.isArray(patientsList?.data) && patientsList.data.length == 0 && <div className={policeClasses.list_item_empty}>No law firms found</div>}
                </div>
                {showDetailsPanel && <>
                    {Array.isArray(patientsList?.data) && patientsList.data.length == 0 && !patientId
                        ? <div className={policeClasses.details_list_item_empty}>No law firms found</div>
                        : <InvalidFaxDetails />}
                </>}
            </div>

            {patientsList?.meta && <div className={classes.pagination_container}>
                <Pagination data={patientsList} apiType="invalid-fax-q" />
            </div>}
        </>}
    </>
}
